import { publishMessageToParentApp } from './utils';
import { PARENT_APP_IFRAME_ID } from './consts';

// parent app trusts the iframe payload, so we can write function body, that will be executed inside parent app using `Function('parentWindow', 'parentDocument', payload)(window, document)`
// this is the reason why we're returning string here and why it is a function body but not a function itself (we can not pass objects via iframe postMessage)
const iframeHeightChangeHandler = (contentHeight: number) => {
  // inside fn body in return you have access to parent app window and document
  // use parentWindow for accessing parent app's window
  // use parentDocument for accessing parent app's document

  return `
    const iframe = parentDocument.getElementById('${PARENT_APP_IFRAME_ID}');
    iframe.style.height = '${contentHeight}px'
  `;
};

export const registerPageHeightChangeEventEmitter = (rootId: string) => {
  if (!window.ResizeObserver) {
    console.error('ResizeObserver is not supported in this browser.');
    return;
  }

  const observer = new ResizeObserver((entries) => {
    for (const { target } of entries) {
      publishMessageToParentApp(iframeHeightChangeHandler(target.scrollHeight));
    }
  });

  observer.observe(document.getElementById(rootId) as HTMLDivElement);
};
